import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';

const action = (
  state: IState,
  actionData: PayloadAction<{ title: string; stationInternalIds: string[] }>,
) => {
  state.activeSpecialEvent.data = actionData.payload;
};

export default action;
